import styled from 'styled-components';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { PhotoCredit } from '@components/PhotoCredit';

export const StyledFlex = styled(Box)`
  width: 165%;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const StyledBox = styled(Box)`
  width: 100%;
  height: 1010px;
  position: relative;
  z-index: 1;
  max-width: 1320px;
  margin: auto;
  display: flex;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledBoxMobile = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    height: 450px;
  }
`;

export const StyledCloudImageMobile = styled(CloudImage)`
  position: absolute;
  z-index: 1;
  top: -14vw;
`;

export const AvatarContainer = styled.div<{ bottom: string; left: string }>`
  position: absolute;
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};
`;

interface Values {
  values: {
    x: number;
    y: number;
    percent: number;
    shouldMove: boolean;
  };
}

interface Props {
  top: string;
  left: string;
  sizeVariant?: string;
  resTop: string;
  resLeft: string;
  resSizeVariant?: string;
}

type MagneticProps = Values & Props;

export const MagneticContainer = styled.div.attrs(({ values: { x, y, percent, shouldMove } }: MagneticProps) => ({
  style: { transform: shouldMove ? `translate3d(${Math.round(x * percent)}px, ${Math.round(y * percent)}px, 0) ` : 'unset' },
}))<MagneticProps>`
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  ${themeMediaQuery('below_sm')} {
    top: ${(props) => props.resTop};
    left: ${(props) => props.resLeft};
  }
`;

export const Tag = styled.div.attrs(({ values: { x, y, percent, shouldMove } }: MagneticProps) => ({
  style: { transform: shouldMove ? `translate3d(${Math.round(x * percent)}px, ${Math.round(y * percent)}px, 0) ` : 'unset' },
}))<MagneticProps>`
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  width: ${(props) => props.sizeVariant};
  ${themeMediaQuery('below_sm')} {
    top: ${(props) => props.resTop};
    left: ${(props) => props.resLeft};
    width: ${(props) => props.resSizeVariant};
    img {
      height: 50px;
    }
  }
`;

export const TextWrapper = styled(Text)`
  text-align: center;
  max-width: 700px;
  ${themeMediaQuery('xl')} {
    max-width: 950px;
  }
`;

export const TagMainTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 490px;
    ${themeMediaQuery('sm')} {
      max-width: 375px;
    }
    ${themeMediaQuery('md')} {
      max-width: 380px;
    }
    ${themeMediaQuery('xl')} {
      max-width: 470px;
    }
  }
  .text-pairing-body {
    max-width: 375px;
    ${themeMediaQuery('xl')} {
      max-width: 440px;
    }
  }
`;

export const BoxContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const LottieContainer = styled.div`
  width: 100%;
  height: 981px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: linear-gradient(180deg, #fffcf7 40%, rgba(255, 252, 247, 0.83) 50%, rgba(255, 252, 247, 0) 100%);
  position: relative;
  ${themeMediaQuery('below_sm')} {
    height: 526px;
  }
`;

export const Lottie = styled.div`
  width: 100%;
  position: absolute !important;
  bottom: -5px;
  left: 0;
  z-index: 1;
  > svg {
    min-height: 578px;
    ${themeMediaQuery('below_sm')} {
      min-height: 315px;
    }
  }
`;

export const ContentWrapper = styled.div`
  margin-top: ${themeSpace(11)};
  z-index: 1;
  position: absolute;
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(9)};
  }
`;

export const DetailWrapper = styled(Box)`
  width: 100%;
  top: 200px;
  z-index: 1;
  position: absolute;
`;

export const SectionCloudImage = styled(CloudImage)`
  width: 100%;
  height: 100%;
`;

export const StyledPhotoCredit = styled(PhotoCredit)`
  ${themeMediaQuery('below_sm')} {
    writing-mode: vertical-rl;
    margin-bottom: ${themeSpace(5)};
    padding: ${themeSpace(5)};
    a span div {
      margin: auto;
    }
  }
`;
